module.exports = __webpack_public_path__ + "img/conimg2-04.2d326f30.png";